import type { CategoryIcon } from '@k2pos/core';
import { Mono, Text } from './Text';
import { CategoryGlyph } from '@/components/icons';
import { colors } from '@/theme/tokens';
import styles from './Chip.module.css';

interface CategoryPillProps {
  name: string;
  icon: CategoryIcon;
  count: number;
  selected: boolean;
  onPress: () => void;
}

/** Category filter pill: glyph + name + count badge, with a sky underline when active. */
export function CategoryPill({ name, icon, count, selected, onPress }: CategoryPillProps) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onPress}
      className={`${styles.pill} ${selected ? styles.pillOn : styles.pillOff}`}
    >
      <CategoryGlyph icon={icon} size={15} className={selected ? styles.iconOn : styles.iconOff} />
      <Text
        weight={selected ? 800 : 700}
        size={12.5}
        color={selected ? colors.surfaceAlt : colors.textMuted}
      >
        {name}
      </Text>
      <span className={`${styles.badge} ${selected ? styles.badgeOn : styles.badgeOff}`}>
        <Mono weight={700} size={10} color={selected ? colors.navy : colors.textMuted}>
          {count}
        </Mono>
      </span>
    </button>
  );
}

interface UnitChipProps {
  unit: string;
  selected: boolean;
  onPress: () => void;
}

/** Unit selector on multi-unit products (ຖົງ / ໂຕນ). */
export function UnitChip({ unit, selected, onPress }: UnitChipProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={onPress}
      className={`${styles.unit} ${selected ? styles.unitOn : styles.unitOff}`}
    >
      <Text weight={700} size={11} color={selected ? '#FFFFFF' : colors.textMuted}>
        {unit}
      </Text>
    </button>
  );
}
